import PropTypes from 'prop-types';
import React from 'react';
import { Paper } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import { DataValueMap } from 'Helpers/Testing';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('TaskHeader', (theme) => ({
  root: {
    backgroundColor: theme.palette.facet.primaryBlueMuted,
    padding: theme.spacing(1, 2),
    margin: theme.spacing(1, 1, 1, 0),
    borderRadius: theme.radius.md,
  },
}));

const TaskHeader = ({
  messageResource,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const actionItems = messageResource.attr('actionItems');
  const actionItemGroup = actionItems.resources().length() > 1;
  const actionItemGroupTitle = `${messageResource?.attr('senderFirstName')} added actions`;
  const singleActionItemTitle = `${messageResource?.attr('senderFirstName')} added an action`;
  const title = actionItemGroup ? actionItemGroupTitle : singleActionItemTitle;

  const testAttributes = DataValueMap.init('task-message-title').build();

  return (
    <Paper className={classes.root}>
      <Text
        value={title}
        align={'left'}
        color={'white'}
        variant={'h5'}
        {...testAttributes}
      />
    </Paper>
  );
};

TaskHeader.propTypes = {
  messageResource: PropTypes.object.isRequired,
};


export default TaskHeader;
